import type { EntityType, FlowType } from 'consts/flows';
import { PROGRESS_BAR_STEPS } from 'consts/progressBar';

const SUFFIX_REGEX = /_\d+$/;

export function Labels(
	steps: string[],
	entityType: EntityType,
	flowType: FlowType,
	t: (key: string) => string
) {
	return steps.reduce((map: { [key: string]: number[] }, pageName, i) => {
		const index = i + 1;
		const suffix = SUFFIX_REGEX.test(pageName) ? '' : `_${index}`;
		const key = `progressbar_${entityType}_${flowType}_${pageName}${suffix}`;
		const translation = t(key);
		if (translation) {
			if (map[translation]) {
				map[translation].push(index);
			} else {
				map[translation] = [index];
			}
		}
		return map;
	}, {});
}

export function buildProgressBarSteps(entityType: EntityType, flowType: FlowType) {
	return PROGRESS_BAR_STEPS[entityType][flowType];
}
